import Skeleton from "react-loading-skeleton";
import { PodcastSkeleton, PodcastsList as StyledPodcastsList } from "./styled";
import PodcastCardMain from "./PodcastCardMain";

export const PodcastsListMain = ({ podcasts, isLoading }) => {
  if (isLoading) {
    return (
      <StyledPodcastsList columns={podcasts?.length}>
        {Array.from({ length: 4 }).map((_, index) => (
          <PodcastSkeleton as={Skeleton} key={index} />
        ))}
      </StyledPodcastsList>
    );
  }

  const lastSixPodcasts = podcasts.slice(-6);

  return (
    <StyledPodcastsList columns={podcasts?.length}>
      {lastSixPodcasts.map((podcast, index) => (
        <PodcastCardMain
          key={podcast.id}
          podcast={podcast}
          duration={index || 1}
        />
      ))}
    </StyledPodcastsList>
  );
};
